import {Route, Routes} from "react-router-dom";
import {Demo_Pay_Route, Login_Route, Orders_Route, Register_Route, Reviews_Route} from "./routes.js";
import Reviews from "../pages/reviews/Reviews.jsx";
import Orders from "../pages/orders/Orders.jsx";
import PrivateRoute from "../components/ProtectedRoutes.jsx";
import Login from "../pages/user/Login.jsx";
import Register from "../components/Register.jsx";
import PaymentComponent from "../pages/demo pay/DemoPay.jsx";

const routes = [
    {path: Login_Route, element: <Login/>, isProtected: false},
    {path: Reviews_Route, element: <Reviews/>, isProtected: true},
    {path: Orders_Route, element: <Orders/>, isProtected: true},
    {path: Register_Route, element: <Register/>, isProtected: true},
    {path: Demo_Pay_Route, element: <PaymentComponent/>, isProtected: true},
];

const AppRoutes = () => {
    return (
        <Routes>
            {routes.map(({path, element, isProtected}) => (
                <Route
                    key={path}
                    path={path}
                    element={isProtected ? <PrivateRoute>{element}</PrivateRoute> : element}
                />
            ))}
        </Routes>
    );
}

export default AppRoutes